import React from "react"

import { Button } from "src/UILibrary"

interface Props {
  caption: string
  onClick?: any
}

export const MoveToTopButton = ({ caption, onClick }: Props) => {
  return (
    <Button
      variant="outlined"
      className="notosans weight700"
      sx={{
        p: "10px",
        my: "10px",
        width: 160,
        fontSize: 16,
        borderRadius: 0,
        borderWidth: 0,
      }}
      color="secondary"
      onClick={() => onClick()}
    >
      {caption}
    </Button>
  )
}
